var render = function render(){var _vm=this,_c=_vm._self._c;return _c('polygon',{attrs:{"id":"plus","fill":_vm.iconColor,"points":"14.5 9.5 22 9.5 22 14.5 14.5 14.5 14.5 22 9.5 22 9.5 14.5 2 14.5 2 9.5 9.5 9.5 9.5 2 14.5 2"}})
}
var staticRenderFns = []

export { render, staticRenderFns }